import React from 'react';
import { Link } from 'react-router-dom';
import { LockOutlined } from '@mui/icons-material'; // Importing the Material UI icon
import { Button, Typography, Box, Paper } from '@mui/material'; // Importing MUI components

export default function NoAuth() {
    return (
        <Box
            sx={{
                height: '100vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: '#f8f9fa',
            }}
        >
            <Paper
                elevation={3}
                sx={{
                    padding: 4,
                    textAlign: 'center',
                    borderRadius: '8px',
                    backgroundColor: '#ffffff',
                    maxWidth: 400,
                }}
            >
                <LockOutlined sx={{ fontSize: 60, color: '#1976d2' }} />
                <Typography variant="h5" component="h2" sx={{ fontWeight: 'bold', marginTop: 2 }}>
                    No Authorization
                </Typography>
                <Typography variant="body1" sx={{ marginTop: 1 }}>
                    You do not have access to this feature. Please contact your administrator if you believe this is an error.
                </Typography>
                <Link to="/home/dashboard" style={{ textDecoration: 'none' }}>
                    <Button
                        variant="contained"
                        color="primary"
                        sx={{ marginTop: 3, paddingX: 4 }}
                    >
                        Go to Profile
                    </Button>
                </Link>
            </Paper>
        </Box>
    );
}
